import { numberMoney } from 'Data/format.js'

export function getValue(payment_plan) {
  let estimated_reimbursement_amount = payment_plan.insurances.reduce(
    (acc, insurance) => acc + insurance.estimated_reimbursement_amount,
    0
  )
  return numberMoney(estimated_reimbursement_amount)
}
